import { AccountManagementFeatureRoutesConfig } from './AccountManagementFeatureRoutesConfig';

export const defaultAccountManagementFeatureRoutesConfig: AccountManagementFeatureRoutesConfig = {
  path: 'my-account',
};
